import React from 'react';
import { IReportsTableFilteringValues, ReportsTableFilteringContext } from '../../contexts/reportsTable/reportsTableFilteringContext';

export function useReportsTableFiltering(): IReportsTableFilteringValues {
    const context = React.useContext(ReportsTableFilteringContext);
    if (!context) {
        throw new Error('useReportsTableFiltering must be wrapped in a ReportsTableFilteringContextProvider');
    }
    return context;
}
